import styles from "./style.module.css";
export default function EllipsisText({ text = "" ,className}) {
  return (
    <div className={`${styles["text-caontainer-el"]}`}>
      <div className={`${styles["ellipsis-text"]} font-normal text-sm ${className}`}>{text}</div>
    </div>
  );
}
